import React from 'react'

const OffBoardElectricCharger = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">EOL Testing</a>
                        <i class="fa fa-angle-right"></i>
                        <span>EOL Testing for Off-Board Electric Vehicle Charger</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/off_board.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>End Of Line (EOL) Testing for Off-Board Electric Vehicle Charger</h2>
                        <p className="mbot25">
                            End-of-Line (EOL) Testing for Off-Board Electric Vehicle (EV) Chargers ensures they meet performance, safety, and quality standards. Key steps include:
                        </p>
                        <p className="mbot25">
                            <ul>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Define Test Parameters:</span> Check input voltage range, output voltage and current accuracy, and efficiency.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Load Testing:</span>Conduct full load, no load, and dynamic load tests.
                                    Protection Features: Verify overcurrent, overvoltage, and thermal protection functionalities.
                                </li>

                                <li>
                                    <span style={{ textDecoration: "underline" }}>Electrical Performance: </span>Measure output ripple, noise levels, and transient response.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Environmental Testing:</span>Test performance under various temperature and humidity conditions.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Functional Verification:</span>Verify startup and shutdown behavior, communication protocols, and electrical isolation.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Safety and Compliance:</span> Ensure regulatory compliance, check leakage current, and ground fault detection.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>User Interface Testing:</span>Test functionality of displays, indicators, and user controls.
                                </li>
                                <li>
                                    <span style={{ textDecoration: "underline" }}>Documentation and Reporting:</span> Maintain test records, perform failure analysis, and generate comprehensive test reports.
                                </li>
                            </ul>
                        </p>
                        <p className="mbot25">
                            These steps ensure off-board EV chargers are reliable, safe, and compliant with standards before shipping.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OffBoardElectricCharger
